<template>
  <q-layout view="lHr lpR lFr">
    <q-page-container>
      <div class="q-pa-md">
        <q-table
          title="Sale"
          :data="data"
          :columns="columns"
          row-key="username"
          :loading="loading"
          color="primary"
          flat
          :filter="filter"
        >
          <template v-slot:top-right>
            <q-input
              borderless
              dense
              debounce="300"
              v-model="filter"
              placeholder="Search"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </template>
          <template v-slot:body-cell-actions="props">
            <q-td class="q-pa-md" :props="props">
              <q-toggle
                v-model="props.row.enable"
                @input="onToggle(props.row)"
              ></q-toggle>
            </q-td>
          </template>
          <template v-slot:body-cell-add-group="props">
            <q-td class="q-pa-md" :props="props">
              <q-btn
                dense
                flat
                icon="group_add"
                color="primary"
                @click="onAdd(props.row)"
              >
              </q-btn>
              <q-btn
                dense
                flat
                icon="group_remove"
                color="negative"
                @click="onRemove(props.row)"
              >
              </q-btn>
            </q-td>
          </template>
        </q-table>
      </div>
      <q-dialog v-model="GroupDialog.show" persistent>
        <q-card style="width: 300px; max-width: 80vw">
          <q-card-section>
            <div class="text-h6">{{GroupDialog.title}}</div>
            <div class="content q-py-sm">
              <div class="row">
                <div class="col-4">Name</div>
                <div class="col-8">{{ GroupDialog.data.name }}</div>
              </div>
              <div class="row">
                <div class="col-4">Email</div>
                <div class="col-8">{{ GroupDialog.data.email }}</div>
              </div>
              <div class="row q-py-sm">
                <div class="col-4">Group</div>
                <q-select
                  class="col-8"
                  v-model="GroupDialog.data.selectedGroup"
                  :options="GroupDialog.data.options"
                  outlined
                  dense
                ></q-select>
              </div>
            </div>
          </q-card-section>
          <q-card-actions align="right" class="bg-white text-teal">
            <q-btn
              flat
              no-caps
              color="accent"
              label="Cancel"
              @click="clearDialog"
            />
            <q-btn
              flat
              no-caps
              color="primary"
              label="Save"
              @click="GroupDialog.onSave"
              :disable="GroupDialog.data.selectedGroup == null"
            />
          </q-card-actions>
        </q-card>
      </q-dialog>
    </q-page-container>
  </q-layout>
</template>

<script>
/* eslint-disable @typescript-eslint/no-empty-function */
import { QTable, QTd, QBtn, QSelect, QMenu, QDialog } from "quasar";
import { mapState } from "vuex";

const components = { QTable, QTd, QBtn, QSelect, QMenu, QDialog };

export default {
  name: "Admin",
  components: {
    ...components,
  },
  data() {
    return {
      filter: null,
      GroupDialog: {
        show: false,
        data: {
          name: null,
          email: null,
          selectedGroup: null,
          options: null 
        },
        onSave: () => {},
      },
      columns: [
        {
          name: "username",
          required: true,
          label: "Username",
          align: "left",
          field: (row) => row.username,
          format: (val) => `${val}`,
          sortable: true,
        },
        {
          name: "email",
          required: true,
          label: "Email",
          align: "left",
          field: (row) => row.email,
          format: (val) => `${val}`,
          sortable: true,
        },
        {
          name: "status",
          required: true,
          label: "Account status",
          align: "center",
          field: (row) => row.status,
          format: (val) => `${val}`,
          sortable: false,
        },
        {
          name: "email_verified",
          required: true,
          label: "Email verified",
          align: "center",
          field: (row) => row.emailVerified,
          format: (val) => `${val}`,
          sortable: false,
        },
        {
          name: "phone number verified",
          required: true,
          label: "Phone number verified",
          align: "center",
          field: (row) => row.phoneVerified,
          format: (val) => `${val}`,
          sortable: false,
        },
        {
          name: "group",
          required: true,
          label: "Group",
          align: "center",
          field: (row) => row.group,
          format: (val) => `${val}`,
        },
        {
          name: "add-group",
          label: "Group action",
          align: "center",
        },
        {
          name: "actions",
          label: "Enable",
          align: "center",
        },
      ],
      data: [],
    };
  },
  computed: {
    ...mapState("admin", ["loading", "user", "groups"]),
    list() {
      if (this.user) {
        return this.user.map((u) => {
          return {
            username: u.Username,
            email: this.getEmail(u.Attributes),
            status: u.UserStatus,
            emailVerified: this.getEmailVerified(u.Attributes),
            phoneVerified: this.getPhoneVerified(u.Attributes),
            enable: u.Enabled,
            group: [],
          };
        });
      }
      return [];
    },
  },
  mounted() {
    console.log("mounted");
    this.$store.dispatch("admin/fetchUser");
    this.$store.dispatch("admin/fetchGroups");
  },
  watch: {
    list: {
      immediate: false,
      handler: function (val) {
        console.log("data >> ", val);
        // this.data = val;
        this.computedGroupList();
      },
    },
  },
  methods: {
    onAdd(props) {
      console.log("onAdd", props);
      this.GroupDialog.title = "Add group to user"
      this.GroupDialog.data.name = props.username;
      this.GroupDialog.data.email = props.email;
      this.GroupDialog.data.options = this.groups;
      this.GroupDialog.onSave = () => {
        this.onAddGroup();
      }
      this.GroupDialog.show = true;
      
    },
    onRemove(props) {
      console.log("onRemove", props);
      this.GroupDialog.title = "Remove user from group"
      this.GroupDialog.data.name = props.username;
      this.GroupDialog.data.email = props.email;
      this.GroupDialog.data.options = props.group;
      this.GroupDialog.onSave = () => {
        this.onRemoveGroup();
      }
      this.GroupDialog.show = true;
    },
    async onToggle(props) {
      console.log("onToggle", props.enable);
      if (!props.enable) {
        console.log("disableUser");
        await this.$store.dispatch("admin/disableUser", props.username);
        return;
      } else {
        console.log("enableUser");
        this.$store.dispatch("admin/enableUser", props.username);
        return;
      }
    },
    async onAddGroup() {
      console.log("onAddGroup", this.GroupDialog);
      await this.$services.admin.addUserToGroup(
        this.GroupDialog.data.name,
        this.GroupDialog.data.selectedGroup
      );
      this.computedGroupList();
      this.clearDialog();
    },
    async onRemoveGroup() {
      console.log("onRemoveGroup", this.GroupDialog);
      await this.$services.admin.removeUserFromGroup(
        this.GroupDialog.data.name,
        this.GroupDialog.data.selectedGroup
      );
      this.computedGroupList();
      this.clearDialog();
    },
    clearDialog() {
      this.GroupDialog.data.name = null;
      this.GroupDialog.data.email = null;
      this.GroupDialog.data.selectedGroup = null;
      this.GroupDialog.show = false;
    },
    getEmail(list) {
      const result = list.find(({ Name }) => Name === "email");
      if (result) {
        return result.Value;
      }
      return "-";
    },
    getEmailVerified(list) {
      const result = list.find(({ Name }) => Name === "email_verified");
      if (result) {
        return result.Value;
      }
      return "-";
    },
    getPhoneVerified(list) {
      const result = list.find(({ Name }) => Name === "phone_verified");
      if (result) {
        return result.Value;
      }
      return "-";
    },
    async getGroupList(username) {
      const { Groups } = await this.$services.admin.getGroupList(username);
      // console.log("getGroupList", Groups);
      const list = Groups.map((g) => {
        return g.GroupName;
      });
      // console.log(list);
      return list;
    },
    async computedGroupList() {
      // this.data = await Promise.all(
      //   this.list.map(async (d) => {
      //     let group = await this.getGroupList(d.username);
      //     return {
      //       ...d,
      //       group: group,
      //     };
      //   })
      // );

      const admin = await this.$services.admin.getListUserInGroup("Admin");
      const sale = await this.$services.admin.getListUserInGroup("Sale");
      const clickzy = await this.$services.admin.getListUserInGroup("Clickzy");

      console.log("computedGroupList", admin, sale)

      this.data = await Promise.all(
        this.list.map(async (user) => {
          let group = [];
          const isAdmin = admin.findIndex((ag) => user.username === ag.Username);
          const isSale = sale.findIndex((ag) => user.username === ag.Username);
          const isClickzy = clickzy.findIndex((ag) => user.username === ag.Username);
          if(isAdmin >= 0){
            // console.log("computedGroupList isAdmin: ", isAdmin)
            group.push("Admin");
          }
          if(isSale >= 0){
            // console.log("computedGroupList isSale: ", isSale)
            group.push("Sale");
          }
          if(isClickzy >= 0){
            // console.log("computedGroupList isSale: ", isSale)
            group.push("Clickzy");
          }
          return {
            ...user,
            group: group,
          };
        })
      );
    },
  },
};
</script>